module.exports = __webpack_public_path__ + "sri-lanka.svg?7a136cf7f317202602d263400e57359d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/sri-lanka.svg
// module id = 303
// module chunks = 10